import React from "react";

export default function Withdrawpage() {
  return (
    <>
      <div className="h-auto col-span-4 xl:col-span-4 shadow-md border rounded-lg">
        <div className="py-8 px-5 w-full">
          <h2 className="text-xl lg:text-2xl text-center pb-6 w-full black-color">
            How to Work With PayCoLife System
          </h2>
          <div className=" px-4 py-5 sm:px-6">
            <h3 className="text-md text-left pb-6 w-full black-color">
              Dear PayCoLife business partners,
              <br /> In order to join the PayCoLife Alternative DropShipping
              system, One reference is required. <br />
              You cannot log in to the system unless you specify a reference. If
              you specify a reference, you can join the system and actively rent
              and use the server you want. In order for you to earn in the
              PayCoLife Alternative DropShipping system, You must rent at least
              1 active server. <br />
              After you have rented a server, the server you rented will earn
              you a certain amount of money on a daily basis. When the 30-day
              limit is reached, you can withdraw the balance if you have reached
              the required reference score. <br />
              <br />
              “The 30-day time limit has expired, but I don't have enough
              reference points. Will my balance be lost?”
              <br /> No! If your server rental period expires, if you did not
              reach enough reference points, do not worry. And work more
              actively to reach the required reference score. The amount you
              earn will appear as "Blocked" until you collect the required
              points and the withdrawal cannot be performed. <br />
              <br />
              Which server is more profitable? <br />
              The servers we offer to you, our valued business partners,
              depending on a certain number of transactions and e-commerce
              sites.
              <br /> Earning rates at the first 3 server levels are slightly
              lower than other server rates. However, it is suitable as an
              alternative and quick way of earning for our business partners
              whose financial situation is not strong. In line with the earnings
              brought by these servers, you can rent a new server and increase
              your earnings rate. <br />
              The scoring system in the PayCoLife Alternative DropShipping
              system, These are the points you earn as a result of each member
              you bring in an active server rental process. <br />
              In the reference point system, each server has a different point
              rate. When each member you bring rents a server, they earn you
              points equal to the point rate of the server they rented. And you
              can examine the additional advantages of these points in detail on
              the scoreboard. <br />
              <br />
              “The member I brought has not rented a server yet, will I earn
              points again?”
              <br /> There is no fixed point you earn from each member you add
              to our family and your family. However, if the server is rented,
              you can earn points equal to the amount of points earned by the
              rented server.
              <br />
              <br />
            </h3>
          </div>
        </div>
      </div>
    </>
  );
}
